/** @app — application layer; owned per-fork (LMS / OTT). See PLATFORM_FILES.md. */
import type { LearningCourseDetail } from '@akademi/site-builder-runtime';
import { Card } from '@akademi/ui';

interface FaqAccordionProps {
  faqs: NonNullable<LearningCourseDetail['faqs']>;
}

export function FaqAccordion({ faqs }: FaqAccordionProps) {
  if (faqs.length === 0) return null;
  return (
    <div className="cd-faq">
      {faqs.map((f, i) => (
        <Card asChild key={i}>
          <details className="cd-faq-item">
            <summary className="cd-faq-q">{f.question}</summary>
            <div className="cd-faq-a">{f.answer}</div>
          </details>
        </Card>
      ))}
    </div>
  );
}
